import type { FormErrors } from 'redux-form';

import type AgencyCreateRM from 'ab-requestModels/agency/create.requestModel';

import { isValidEmail } from '@acceligentllc/shared/utils/email';
import { isValidPhoneNumber } from '@acceligentllc/shared/utils/phone';
import { isValidTextInput } from '@acceligentllc/shared/utils/text';

import { URL_REGEX } from '@acceligentllc/shared/constants/regex';

export function validate(form: AgencyCreateRM) {
	const errors: FormErrors<AgencyCreateRM> = {};

	if (!isValidTextInput(form.name)) {
		errors.name = 'Agency name is required.';
	}
	if (!form.color) {
		errors.color = 'Agency color is required';
	}

	if (!!form.email) {
		if (!isValidEmail(form.email)) {
			errors.email = 'Invalid E-mail';
		}
	}
	if (!!form.phone && !isValidPhoneNumber(form.phone)) {
		errors.phone = 'Invalid phone number';
	}

	if (!!form.website) {
		if (!URL_REGEX.test(form.website)) {
			errors.website = 'Invalid url';
		}
	}

	return errors;
}
